// eslint-disable-next-line import/prefer-default-export
export const renderTemplate = (template, data) => {
  // eslint-disable-next-line no-template-curly-in-string
  const processedTemplate = template.replace(/<%= (.*?) %>/g, '${data.$1}');
  // eslint-disable-next-line no-new-func
  return new Function('data', `return \`${processedTemplate}\`;`)(data);
};
